import { useEffect }                                from 'react';
import Select                                       from 'react-select';
import { Dialog, DialogBackdrop, DialogPanel }      from '@headlessui/react';
import { useForm, Controller }                      from "react-hook-form";
import { colourStyles, SelectCustomStyles }         from "../../utils/stylesUtils";

const FarolForm = ({ 

    isOpen, 
    onClose,
    onSubmit, 
    isEditMode, 

    formEditValues,
    handleDelete,

    optionsRestrictions,
    optionsProducts,
    optionsClients,
    optionsCategories,
    optionsHoopers

}) => {

    const { 

        register, 
        handleSubmit, 
        control, 
        setValue, 
    
    } = useForm();


    const _setupCreateNewFarol = () => {

        setValue('hooper', null);
        setValue('client', null);
        setValue('product', null);
        setValue('farolRestriction', null);
        setValue('category', null);
        setValue('description', '');
        
    }

    const _setupEditFarol = () => {
        
        const { description, categoryId, productId, hooperId, clientId, farolRestrictionId } = formEditValues

        const selectedCategory    = optionsCategories?.find(opt => opt.value === categoryId)
        const selectedProduct     = optionsProducts?.find(opt => opt.value === productId)
        const selectedClient      = optionsClients?.find(opt => opt.value === clientId)
        const selectedRestriction = optionsRestrictions?.find(opt => opt.value === farolRestrictionId)
        const selectedHooper      = optionsHoopers ? optionsHoopers.find(opt => opt.value === hooperId) : null
        
        setValue('hooper', selectedHooper);
        setValue('client', selectedClient);
        setValue('product', selectedProduct);
        setValue('farolRestriction', selectedRestriction);
        setValue('category', selectedCategory);
        setValue('description', description);
    }

    useEffect(() => {

        (isEditMode && formEditValues) ? _setupEditFarol() : _setupCreateNewFarol()
        
    }, [ formEditValues, isEditMode ]);

    return (

        <Dialog open={isOpen} onClose={onClose} onSubmit={onSubmit} className="relative z-[100]">

            <DialogBackdrop transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>
            
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    
                    <DialogPanel transition className="w-[808px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">   
                        
                        <div className="app-container">
                            
                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                                
                                <h2 className="text-white text-[1rem] leading-7 font-semibold">{!isEditMode ? "Novo" : "Editar"} Farol de Terminais</h2>
                                <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2">×</button>
                                
                            </header>

                            {/* Inputs */}
                            <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4">

                                {/* Restriction */}
                                <div className="flex flex-col w-full mb-4">
                            
                                        <span className="text-sm font-semibold">Restrição:</span>
                                        
                                        <Controller
                                            control={control}
                                            name="farolRestriction"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={optionsRestrictions}
                                                    styles={colourStyles}
                                                    className="basic-select"
                                                    classNamePrefix="select"
                                                    isSearchable={false}
                                                />
                                            )}
                                        />
                                </div>

                                <div className="flex flex-row gap-2 mb-4">
                               
                                    {/* Hooper */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Moega:</span>
                                        <Controller
                                            control={control}
                                            name="hooper"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={[{ label: 'Nenhuma', value: null }, ...optionsHoopers]}
                                                    styles={SelectCustomStyles}
                                                    isDisabled={optionsHoopers.length === 0}
                                                />
                                            )}
                                        />
                                    </div>
                                    
                                    {/* Client */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Cliente:</span>
                                        <Controller
                                            control={control}
                                            name="client"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={[{ label: 'Nenhum', value: null }, ...optionsClients]}
                                                    className="basic-select"
                                                    classNamePrefix="select"
                                                    isSearchable
                                                    
                                                />
                                            )}
                                        />
                                    </div>

                                </div>
                                        
                                <div className="flex flex-row gap-2 mb-4">
                                    
                                    {/* Product*/} 
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Produto:</span>
                                        <Controller
                                            control={control}
                                            name="product"
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={[{ label: 'Nenhuma', value: null }, ...optionsProducts]}
                                                    className="basic-select"
                                                    classNamePrefix="select"
                                                    isSearchable
                                                />
                                            )}
                                        />
                                    </div>

                                </div>

                                {/* Category */}            
                                <div className="flex flex-col mb-4">
                                    <span className="text-sm font-semibold">Categoria:</span>
                                    <Controller
                                        control={control}
                                        name="category"
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={[...optionsCategories]}
                                                className="basic-select"
                                                classNamePrefix="select"
                                                isSearchable
                                            />
                                        )}
                                    />
                                </div>

                                {/* Description */}            
                                <div className="flex flex-col mb-4">
                                    <span className="text-sm font-semibold">Descrição:</span>      
                                    <textarea 
                                        id="multiLineInput" 
                                        rows="5" 
                                        className="border border-gray-300 rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 blue-scrollbar" 
                                        placeholder="Escreva aqui..." 
                                        {...register("description", { required: false })}
                                    ></textarea>
                                </div>

                            </div>
                                    
                            {/* Buttons */}
                            <div className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    type="submit" 
                                    onClick={handleSubmit(onSubmit)} 
                                    className="btn btn-azul-prof sm:ml-3 w-[50%] text-[1.125rem]"
                                >
                                    Salvar
                                </button>

                                {isEditMode?<button 
                                    type="submit" 
                                    onClick={() => {handleDelete()}} 
                                    className="btn btn-vermelho sm:ml-3 w-[50%] text-[1.125rem]"
                                >
                                    Excluir
                                </button>: null}

                                <button 
                                    type="button" 
                                    onClick={onClose} 
                                    className="btn btn-cinza w-[50%] text-[1.125rem]"
                                >
                                    Cancelar
                                </button>

                            </div>
                            
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>

    );
};

export default FarolForm;